import availabilityActions from './actions/availability';
import chatActions from './actions/chat';
import connectionsActions from './actions/connections';
import directoryActions from './actions/directory';
import enrichmentsActions from './actions/enrichments';
import eventsActions from './actions/events';
import exhibitorsActions from './actions/exhibitors';
import formsActions from './actions/forms';
import i18nActions from './actions/i18n';
import locationsActions from './actions/locations';
import meetingsActions from './actions/meetings';
import newsActions from './actions/news';
import notificationsActions from './actions/notifications';
import onlineUsersActions from './actions/onlineUsers';
import participantsActions from './actions/participants';
import programActions from './actions/program';
import pushNotificationsActions from './actions/pushNotifications.js';
import questionsActions from './actions/questions';
import sessionActions from './actions/session';
import speakersActions from './actions/speakers';
import uiActions from './actions/ui';
import usersActions from './actions/users';
import votingActions from './actions/voting';
import collectActions from './actions/collect';
import onceActions from './actions/once';
import directoryTagsActions from './actions/directoryTags.js';
import directoryFilterActions from './actions/directoryFilter.js';
import leadsActions from './actions/leads';
import * as demoActions from './actions/demo';

export default {
    set: (key, value) => ({ type: 'SET', key, value }),
    restoreState: (state) => ({ type: 'RESTORE_SAVED_STATE', state }),
    demo: demoActions,
    session: sessionActions,
    events: eventsActions,
    users: usersActions,
    i18n: i18nActions,
    enrichments: enrichmentsActions,
    participants: participantsActions,
    questions: questionsActions,
    program: programActions,
    speakers: speakersActions,
    ui: uiActions,
    news: newsActions,
    meetings: meetingsActions,
    directory: directoryActions,
    locations: locationsActions,
    availability: availabilityActions,
    notifications: notificationsActions,
    pushNotifications: pushNotificationsActions,
    connections: connectionsActions,
    chat: chatActions,
    exhibitors: exhibitorsActions,
    forms: formsActions,
    voting: votingActions,
    onlineUsers: onlineUsersActions,
    collect: collectActions,
    once: onceActions,
    directoryTags: directoryTagsActions,
    directoryFilter: directoryFilterActions,
    leads: leadsActions,
};
